define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'readingiq-src/js/riq-js/riq-analytics-service/1.0.1/index-impl',
  'readingiq-src/js/riq-js/riq-api-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-user-state-service/1.0.0/index',
  'readingiq-src/js/riq-js/app-session-state-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-server-time-service/1.0.0/index'
  /* eslint-enable */
], function service(app, riqAnalyticsServiceImpl) {
  'use strict';

  app.registerFactory('riqAnalyticsService', [
    '$window',
    'riqApiService',
    'riqServerTimeService',
    riqAnalyticsServiceImpl
  ]);
});
